'use client';

import { atom, useAtomValue, useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import type React from 'react';

import { store } from '@/legacy/components/apps/Jotai';
import styles from '@/legacy/components/apps/modal.module.scss';
import { clc } from '@/legacy/components/base/utils';

type Theme = 'dark' | 'light';

export const freezeAtom = atom(false);
export const themeAtom = atom<Theme>('dark');

export const useSetFreeze = () => {
	const setFreeze = useSetAtom(freezeAtom);
	return setFreeze;
};

export const themeAtomSet = (data: Theme) => store.set(themeAtom, data);

type Props = {
	children: React.ReactNode;
};

// const pretendard = localFont({
// 	src: './PretendardVariable.woff2',
// 	display: 'swap',
// 	weight: '45 920',
// 	variable: '--font-pretendard',
// })

const commonFreeze = (e: Event) => {
	e.preventDefault();
};
const keyEventFreeze = (e: KeyboardEvent) => {
	if (e.code === 'Escape') {
		return;
	}
	e.preventDefault();
};

/**
 * root layout 에 사용중임
 * @param param0
 * @returns
 */
const Freeze = ({ children }: Props) => {
	const isFreeze = useAtomValue(freezeAtom);
	const theme = useAtomValue(themeAtom);
	const path = usePathname();
	console.log('path:::', path);

	const isFeed = path.includes('/feed/');

	// const ref = useRef<HTMLBodyElement>(null)
	// // if (isFreeze) {
	// // 	if (ref.current) {
	// // 		window.document.scrollingElement?.scrollTo({ top: 0, behavior: 'instant' })
	// // 	}
	// // }
	// if (ref.current) {
	// 	window.document.scrollingElement?.scrollTo({ top: 0, behavior: 'instant' })
	// }

	return (
		<body
			className={clc(
				// pretendard.variable,
				isFreeze && styles.lock,
				isFreeze && styles.scrollPadding,
				isFeed && 'feed',
				theme
			)}
		>
			{children}
		</body>
	);
};

export default Freeze;
